import { tokenize } from "./lexer.js";
import { Parser } from "./parser.js";

export function validateRule(text) {
    const { tokens, errors: lexErrors } = tokenize(text);
    const parser = new Parser(tokens);
    const ast = parser.parse();
    const errors = [...lexErrors, ...parser.errors];
    return { ast, errors };
}
